import React, { useState } from 'react';

const SIZE = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-lg',
};

function initials(name = '') {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? '?';
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const Avatar = ({ src, name = '', size = 'md', className = '', ...rest }) => {
  const [failed, setFailed] = useState(false);
  const sizeStyle = SIZE[size] || SIZE.md;

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name || 'Avatar'}
        onError={() => setFailed(true)}
        className={`rounded-full object-cover bg-app-surface-hover ${sizeStyle} ${className}`}
        {...rest}
      />
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-primary/10 text-primary font-semibold select-none ${sizeStyle} ${className}`}
      title={name}
      {...rest}
    >
      {initials(name)}
    </span>
  );
};

export default Avatar;
